export default "__VITE_ASSET__C2nIe1S1__"